import {FlexColumn, FlexRow, SubHeading, Text} from '@forecast-it/design-system';
import React from 'react';
import {useIntl} from 'react-intl';
import styled from 'styled-components';
import Util from '../../forecast-app/shared/util/util';
import {BaselineTotals} from './BaselineTypes';

const SummaryContainer = styled(FlexRow)`
	padding: 8px;
`;

const SummaryCard = (props: {label: string; value: string}) => (
	<FlexColumn>
		<Text color="auxiliary" size={'2'}>
			{props.label}
		</Text>
		<SubHeading size={'2'}>{props.value}</SubHeading>
	</FlexColumn>
);

export const FinancialsSummary = ({currency, phaseBaselineTotals}: {currency: string; phaseBaselineTotals: BaselineTotals}) => {
	const intl = useIntl();
	const {formatMessage, formatNumber} = intl;

	const formatCurrency = (value: number) =>
		formatNumber(value, {style: 'currency', currency, currencyDisplay: 'narrowSymbol'});

	const {baselineCost, baselineMargin, baselineMinutes, baselineProfit, baselineRevenue, baselineTimeAndExpenses} =
		phaseBaselineTotals || {};

	const hours = Util.convertMinutesToFullHour(baselineMinutes || 0, intl);
	const valueOfService = formatCurrency(Util.roundFloatToTwoDecimals(baselineTimeAndExpenses || 0));
	const revenue = formatCurrency(Util.roundFloatToTwoDecimals(baselineRevenue || 0));
	const cost = formatCurrency(Util.roundFloatToTwoDecimals(baselineCost || 0));
	const profit = formatCurrency(Util.roundFloatToTwoDecimals(baselineProfit || 0));
	const margin = Util.getFormattedPercentage(baselineMargin, intl);

	return (
		<SummaryContainer justifyContent="center">
			<SummaryCard label={formatMessage({id: 'common.hours'})} value={hours} />
			<SummaryCard label={formatMessage({id: 'common.value_of_service'})} value={valueOfService} />
			<SummaryCard label={formatMessage({id: 'project_budget.revenue'})} value={revenue} />
			<SummaryCard label={formatMessage({id: 'common.cost'})} value={cost} />
			<SummaryCard label={formatMessage({id: 'common.profit'})} value={profit} />
			<SummaryCard label={formatMessage({id: 'common.margin'})} value={margin} />
		</SummaryContainer>
	);
};
